import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useNumberParams from '../../../../../hooks/useNumberParams';
import { useTranslation } from 'react-i18next';
import CusUploadImage from '../../../../../components/material-ui/CusUploadImage';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import { useAppSelector } from '../../../../../store';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';
import DeleteDialog from '../../../../../components/material-ui/dialog/DeleteDialog';
import { dispatchCusEvent } from '../../../../../utils';
import { ENUM_CUS_EVENT } from '../../../../../enums/enums';

export default function CasinoLogoContent({ casino }) {
  const { t } = useTranslation();
  const { isMobile } = useBootstrapSize();
  const { successToast } = useToast();
  const casinos = useAppSelector((state) => state.user.info.casino);
  const [fileLogo, setFileLogo] = useState({});
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const casinoId = useNumberParams('casinoId');

  const updateCasino = () => {
    dispatchCusEvent(ENUM_CUS_EVENT.getCasinos);
  };

  const onDeleteLogo = () => {
    API_CASINO.logo
      .del({ casinoId })
      .then(() => {
        successToast('Information updated successfully');
        updateCasino();
        setFileLogo({ fileName: '', fileUrl: undefined, fileData: '' });
      })
      .catch(console.error);
  };

  useEffect(() => {
    const currentCasino = casinos.find((c) => c.id === casinoId);
    if (currentCasino && currentCasino.logo) {
      setFileLogo({ fileUrl: currentCasino.logo });
    }
  }, [casinoId]);

  const onSaveClick = () => {
    console.log('fileLogo', fileLogo);

    if (fileLogo.fileData) {
      API_CASINO.logo
        .set({ casinoId, fileData: fileLogo.fileData, fileName: fileLogo.fileName })
        .then(() => {
          successToast('Information updated successfully');
          updateCasino();
        })
        .catch(console.error);
      return;
    }
  };

  const imageSource = fileLogo.fileUrl
    ? `https://${casino.domain}${fileLogo.fileUrl}`
    : fileLogo.base64Full;

  return (
    <>
      <Stack gap={3}>
        <CusUploadImage
          maxSizeMB={1}
          flexDirection={isMobile ? 'column' : 'row'}
          bannerNearby={!isMobile}
          title={'Logo'}
          id={'mobileBannerFile'}
          onCrossClick={() => setOpenDeleteDialog(true)}
          tooltip={t(
            'Files in the following formats are allowed for upload: png, webp, jpg, jpeg, and gif. File size must not exceed 1 MB. File names may only contain Latin letters, numbers, dashes, and underscores.'
          )}
          imageSource={imageSource}
          onChange={(base64Full, name) => {
            const base64 = base64Full.split('base64,')[1];
            setFileLogo({
              fileName: name,
              fileUrl: undefined,
              fileData: base64,
              base64Full
            });
          }}
        />
        <CasinoBtnSave onClick={onSaveClick} />
      </Stack>

      <DeleteDialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onConfirm={onDeleteLogo}
      />
    </>
  );
}
